import { getCompanyDetail } from '~/api/company.api'
import { getTechSupport } from '~/api/common.api'
export const actions = {
  async nuxtServerInit({ commit }, { route }) {
    const companyId = route.params.companyId
    if (companyId && /^\d+$/.test(companyId)) {
      const company = await getCompanyDetail({
        companyId
      })
      const techSupport = await getTechSupport({ companyId })

      commit('company/setCompanyState', company)
      commit('company/setCompanyTechSupport', techSupport)
    }
  }
}
